import React, {useState, useRef, useEffect } from "react";
import {is} from 'ramda'
import {useIntl} from 'gatsby-plugin-intl';
import {
  CardIcon,
  CardHeader,
  ImageContainer,
  CardTitle,
  CardContent,
  Card,
  ExpandButton,
} from './expandableCard.styles'
import { renderWhenTrue } from '../../utils/rendering';
import { CustomTooltip } from '../customTooltip'

const renderCardIcon = ( url ) => renderWhenTrue(() => <CardIcon src={url} />)(!!url);

const renderInfoIcon = (connection, citation) => {
  return (
    <CustomTooltip connection={connection} citation={citation} />
  )
}

const renderCardTitle = ({ value }) => {
  const {formatMessage} = useIntl()
  if(!value) return null
  return <CardTitle>{formatMessage({ id: value })}</CardTitle>
}

const renderCardHeader = (cardTitle, connection, citation, cardIconUrl) => {
  const {formatMessage} = useIntl()
  if (!cardIconUrl.value.image) {
    return (
    <CardHeader>
      <ImageContainer>
        {renderCardTitle(cardTitle)}
        {renderInfoIcon(connection, citation)}
      </ImageContainer>
    </CardHeader>
    )
  }
   else return (
    <CardHeader>
      <ImageContainer hasIcon={cardIconUrl.value.image}>
        {renderCardIcon(cardIconUrl.value.image)}
        {renderInfoIcon(connection)}
      </ImageContainer>
      <CardTitle>{formatMessage({ id: cardTitle.value })}</CardTitle>
    </CardHeader>
  )
}

export const ExpandableCard = ({ cardTitle, cardIcon, connection, citation, markdown }) => {
  const [expand, setExpand] = useState(false)
  const [isClamped, setIsClamped] = useState(false)
  const contentRef = useRef(null)
  const { formatMessage } = useIntl();

  useEffect(() => {
    const scrollHeight = contentRef.current.children[1].scrollHeight
    const clientHeight = contentRef.current.children[1].clientHeight
    if(scrollHeight > clientHeight) setIsClamped(true)
  }, [])
  const handleExpand = () => {
    setExpand(!expand)
  }

  if(!markdown.value || !is(String, markdown.value)) return null

  return (
    <Card className={expand ? 'hidden' : null} ref={contentRef}>
      {renderCardHeader(cardTitle, connection, citation, cardIcon)}
      <CardContent className={expand ? 'hidden' : null} >
        {formatMessage({ id: markdown.value })}
      </CardContent>
      {isClamped ?
        <ExpandButton onClick={handleExpand}>
          { expand ? formatMessage({ id: 'Read Less'}) : formatMessage({ id: 'Read More'})}
        </ExpandButton>
        : null }
    </Card>
  )
}
